export default __webpack_public_path__ + "static/planning-development-accomplishment-4-f9ed878e27d4610eb2dd98ad91ea34e0.webp";